import { render, staticRenderFns } from "./ShipRepairPracticeUpsertForm.vue?vue&type=template&id=b23b7484"
import script from "./ShipRepairPracticeUpsertForm.vue?vue&type=script&lang=ts"
export * from "./ShipRepairPracticeUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports